// Bilingual Privacy Policy + Terms of Service content
// Note: This is a starter template. Soo should have it reviewed by a Malaysian lawyer before public launch.

export const PRIVACY = {
  title_zh: '隐私政策',
  title_en: 'Privacy Policy',
  effective_zh: '生效日期：2026 年 2 月',
  effective_en: 'Effective: February 2026',
  intro_zh:
    'You & Me Lactation Coach（以下简称「我们」）致力于保护使用者的个人资料隐私。本政策依照马来西亚 2010 年个人资料保护法（PDPA）撰写，说明我们如何收集、使用和保护你的资讯。',
  intro_en:
    'You & Me Lactation Coach ("we", "us") is committed to protecting your privacy. This policy is drafted in line with Malaysia\u2019s Personal Data Protection Act 2010 (PDPA) and explains how we collect, use, and protect your information.',
  sections: [
    {
      heading_zh: '我们收集哪些资料',
      heading_en: 'What we collect',
      points_zh: [
        '自我检测的答案：产后天数、喂养方式、疼痛分数、发烧/红肿/硬块等症状描述',
        '奶量记录：日期、方式（亲喂/挤奶/手挤）、左右奶量、备注',
        '可选位置/月子中心名称',
        '若你选择通过 WhatsApp 联系，将分享上述总结予 Soo',
        '基本浏览资讯：语言偏好、localStorage 暂存的进度',
      ],
      points_en: [
        'Self-check answers: postpartum stage, feeding method, pain score, fever/redness/lump descriptions',
        'Milk log entries: date, method (latch/pump/hand), left/right volumes, notes',
        'Optional area / confinement-centre name',
        'If you choose to message via WhatsApp, the summary above is shared with Soo',
        'Basic browser context: language preference and locally stored progress',
      ],
    },
    {
      heading_zh: '我们如何使用这些资料',
      heading_en: 'How we use it',
      points_zh: [
        '提供哺乳教育与初步分流',
        '将案例分配给合适的泌乳顾问',
        '后续跟进与服务安排',
        '改进系统建议与教学资源（仅以汇总、去识别的方式）',
      ],
      points_en: [
        'To provide breastfeeding education and initial triage',
        'To assign cases to a suitable lactation consultant',
        'To follow up and arrange services',
        'To improve our guidance and library (only in aggregate, de-identified form)',
      ],
    },
    {
      heading_zh: '谁会看到你的资料',
      heading_en: 'Who can see your data',
      points_zh: [
        '创办人 Soo Li Theng',
        '你指定或平台分配的泌乳顾问',
        '我们不会将你的资料出售或分享给广告商或第三方',
      ],
      points_en: [
        'Founder Soo Li Theng',
        'The lactation consultant you choose or who is assigned to you',
        'We do not sell or share your data with advertisers or third parties',
      ],
    },
    {
      heading_zh: '资料保留期',
      heading_en: 'Retention',
      points_zh: [
        '案例记录预设保留 24 个月，之后将被删除或匿名化',
        '如你主动要求删除资料，我们会在 30 天内处理',
      ],
      points_en: [
        'Case records are retained for 24 months by default and then deleted or anonymised',
        'If you request deletion, we will process it within 30 days',
      ],
    },
    {
      heading_zh: '你的权利',
      heading_en: 'Your rights',
      points_zh: [
        '查阅你的资料',
        '更正或更新资料',
        '撤回同意',
        '要求删除资料',
        '请以 WhatsApp 联系 +60 13-225 3943 行使任何上述权利',
      ],
      points_en: [
        'Access your data',
        'Correct or update your data',
        'Withdraw consent',
        'Request deletion',
        'Contact us via WhatsApp +60 13-225 3943 to exercise any of these rights',
      ],
    },
    {
      heading_zh: 'Cookies 与 localStorage',
      heading_en: 'Cookies & localStorage',
      points_zh: [
        '我们仅使用必要的浏览器储存（localStorage）来保存你的语言偏好和正在进行中的自我检测进度',
        '不使用第三方追踪 cookies',
      ],
      points_en: [
        'We only use essential browser storage (localStorage) for your language preference and in-progress self-check',
        'No third-party tracking cookies are used',
      ],
    },
    {
      heading_zh: '联络我们',
      heading_en: 'Contact us',
      points_zh: ['WhatsApp: +60 13-225 3943', '负责人：Soo Li Theng'],
      points_en: ['WhatsApp: +60 13-225 3943', 'Data controller: Soo Li Theng'],
    },
  ],
};

export const TERMS = {
  title_zh: '服务条款',
  title_en: 'Terms of Service',
  effective_zh: '生效日期：2026 年 2 月',
  effective_en: 'Effective: February 2026',
  intro_zh:
    '使用 You & Me Lactation Coach 即表示你同意以下条款。请在使用前仔细阅读。',
  intro_en:
    'By using You & Me Lactation Coach you agree to the following terms. Please read carefully before use.',
  sections: [
    {
      heading_zh: '非诊断声明（重要）',
      heading_en: 'Non-diagnostic Disclaimer (Important)',
      points_zh: [
        '本工具提供哺乳教育和初步分流，并非医疗诊断',
        '所有结果、建议和教学仅作参考',
        '如出现以下情况，请尽快就医：体温 38°C 或以上、红肿范围扩大、剧烈疼痛、宝宝精神差或拒绝喝奶',
        '紧急情况请直接拨打 999 或前往最近的医院',
      ],
      points_en: [
        'This tool provides breastfeeding education and initial triage. It is not a medical diagnosis.',
        'All results, advice, and teaching are for reference only.',
        'Seek medical care promptly if you have: fever 38°C or above, spreading redness, severe pain, baby seems unwell or refuses feeds.',
        'For emergencies, call 999 or go to your nearest hospital.',
      ],
    },
    {
      heading_zh: '服务范围',
      heading_en: 'Services',
      points_zh: [
        '视频咨询、上门无痛通乳、挤奶器配对咨询、一个月哺乳陪跑',
        '具体收费、时间、地点将通过 WhatsApp 沟通确认',
      ],
      points_en: [
        'Video call consultation, home-visit painless lactation, pump fitting, one-month breastfeeding coaching',
        'Fees, scheduling, and location are confirmed via WhatsApp',
      ],
    },
    {
      heading_zh: '预约与取消',
      heading_en: 'Booking & cancellation',
      points_zh: [
        '请提前 24 小时取消或改期，以方便顾问安排',
        '上门服务的具体退款条款将于预约确认时告知',
      ],
      points_en: [
        'Please cancel or reschedule at least 24 hours in advance so consultants can plan',
        'Refund terms for home-visit services will be communicated at booking',
      ],
    },
    {
      heading_zh: '责任限制',
      heading_en: 'Limitation of liability',
      points_zh: [
        '我们提供的资讯和服务并非医疗诊断，使用者需自行评估并对自己的健康决定负责',
        '在法律允许的最大范围内，You & Me Lactation Coach 不对使用本工具产生的任何间接损害负责',
      ],
      points_en: [
        'Our information and services are not medical diagnoses. You are responsible for evaluating your own health decisions.',
        'To the fullest extent permitted by law, You & Me Lactation Coach is not liable for any indirect damages arising from use of this tool.',
      ],
    },
    {
      heading_zh: '智慧财产',
      heading_en: 'Intellectual property',
      points_zh: [
        '所有教学资料、文字、图像、视频归 You & Me Lactation Coach 所有',
        '欢迎妈妈个人转发分享，但不得用于商业用途',
      ],
      points_en: [
        'All teaching materials, text, images, and videos belong to You & Me Lactation Coach',
        'Mothers are welcome to share for personal use, but not for commercial purposes',
      ],
    },
    {
      heading_zh: '修订',
      heading_en: 'Updates',
      points_zh: ['我们保留更新条款的权利，重大修改将于本页公布。'],
      points_en: ['We may update these terms. Material changes will be posted on this page.'],
    },
    {
      heading_zh: '联络',
      heading_en: 'Contact',
      points_zh: ['WhatsApp: +60 13-225 3943'],
      points_en: ['WhatsApp: +60 13-225 3943'],
    },
  ],
};
